import React from 'react';
import { store } from '@/store/store.index';
import MqttService from 'Api/service/MqttService';
import { collaborationService } from '../index';
import { Modal } from 'antd';
const { info } = Modal;
import { ExclamationCircleOutlined } from '@ant-design/icons';

export default class CollaborationMqttService {
  constructor() {
    this.collaborationMqttService = null;
    this.handler = this.handler.bind(this)
    this.isPublic = false
  }
  isConnected() {
    if (!this.collaborationMqttService) {
      return false
    }
    return this.collaborationMqttService.isConnected();
  }
  connect({ serverUrl, port }) {
    if (!serverUrl) {
      return;
    }
    this.collaborationMqttService = new MqttService({ serverUrl, port, msgHandler: this.handler });
    this.collaborationMqttService.connect();
    this.collaborationMqttService.subscribe({topic:`shareReview/${store.collaborationStore.reviewSessionID}`})
  }
  end({ force, options, callback } = {}) {
    this.collaborationMqttService.end({ force, options, callback });
  }
  handler({ topic, message, /* packet */ }) {
    const msg = JSON.parse(message.toString())
    switch (topic) {
      case `shareReview/${store.collaborationStore.reviewSessionID}`:
        this.shareReviewNotice(msg);
        break;
      default:
        break;
    }
  }
  publish(type, info) {
    this.isPublic = true
    this.collaborationMqttService.client && this.collaborationMqttService.client.publish(`shareReview/${store.collaborationStore.reviewSessionID}`, JSON.stringify({reviewType:type,...info}))
    setTimeout(() => {
      this.isPublic = false
    }, 3000)
  }
  shareReviewNotice(message) {
    const { reviewType } = message;

    switch (reviewType) {
      // 创建
      case 'newReview':
        this.newReview(message);
        break;
      // 删除
      case 'deleteShareReview':
        this.deleteReview(message);
        break;
      // 修改
      case 'modifyShareReview':
        this.modifyReview(message);
        break;
      // 增加参与者
      case 'joinShareReview':
        this.joinReview(message);
        break;
      // 参与者离开
      case 'leaveShareReview':
        this.leaveReview(message);
        break;
      // 添加annot
      case 'newAnnot':
        this.newAnnot(message);
        break;
      // 修改annot
      case 'modifyAnnot':
        this.modifyAnnot(message);
        break;

      // 协同二期——删除人员，更新人员列表
      case 'removeCollaboratorUser':
        // if(this.isPublic) {
        //   this.isPublic = false
        //   return
        // }
        this.removeCollaboratorUser(message)
        break
      // 协同二期——添加人员，更新人员列表
      case 'addCollaboratorUser':
        this.addCollaboratorUser(message)
        break
      // 协同二期——取消分享
      case 'cancelShareUser':
        this.cancelShareUser()
        break
      // 协同二期 —— 修改用户权限，特定人访问
      case 'changeToAppointorShare':
        if(this.isPublic) {
          this.isPublic = false
          return
        }
        this.changeToAppointorShare(message)
        break
      // 协同二期 —— 所有人可查看或评论 触发
      case 'changeAnyShareType': {
        if(this.isPublic) {
          this.isPublic = false
          return
        }
        this.changeAnyShareType(message)
        break
      } 
      case 'changeShareUserAuth': {
        if(this.isPublic) {
          this.isPublic = false
          return
        }
        this.changeShareUserAuth(message)
        break
      }
      case 'ReviewOptions':
        this.showCollabOp(message);
        break;
      default:
        break;
    }
  }
  showCollabOp({ reviewSessionID, cUserID,operate}){

    collaborationService.showCollabOp(reviewSessionID, cUserID,JSON.parse(operate))
  }
  modifyAnnot({ reviewSessionID, cUserID, updateTime, pageObjNum, annotType, delFlag, annotName, pageIndex, reviewClientID }) {
    //console.log('modify annot mqtt');
    const lastTime = updateTime
    const { uuidForCollaboration } = store.collaborationStore
    // if (cUserID === store.userStore.userInfo.cUserID && reviewClientID === uuidForCollaboration) {
    if (cUserID == store.userNewStore.userData.userId && reviewClientID === uuidForCollaboration) {
      return
    }
    if (delFlag === 1) {
      sessionStorage.setItem("fwCollaboration", true)
      collaborationService.deleteAnnot({annotName, pageIndex, isDeleteLocal: true, cUserID})
    } else {
      console.log("collaborationService.getAnnotListAll 2")
      collaborationService.getAnnotListAll({reviewSessionID, lastTime, pageObjNum, annotType})
    }
  }
  newAnnot({ reviewSessionID, cUserID, updateTime, pageObjNum, annotType, reviewClientID }) {
    //console.log('new annot mqtt');
    const { uuidForCollaboration } = store.collaborationStore
    if (cUserID == store.userNewStore.userData.userId && reviewClientID === uuidForCollaboration) {
      return
    }
    console.log("collaborationService.getAnnotListAll 3")
    collaborationService.getAnnotListAll({reviewSessionID, lastTime: updateTime, pageObjNum, annotType})
  }
  leaveReview({ reviewSessionID, cUserID }) {
    if (store.userNewStore.userData && store.userNewStore.userData.userId && store.userNewStore.userData.userId == cUserID) {
      return;
    }
    store.collaborationStore.queryShareViewData({
      reviewSessionID: reviewSessionID,
      getMore: 1
    })
  }
  joinReview({ reviewSessionID }) {
    store.collaborationStore.queryShareViewData({
      reviewSessionID: reviewSessionID,
      getMore: 1
    })
  }
  async modifyReview({ reviewSessionID, cUserID, reviewClientID }) {
    const { uuidForCollaboration } = store.collaborationStore

    if (store.userStore.userInfo && store.userStore.userInfo.cUserID && store.userStore.userInfo.cUserID === cUserID && reviewClientID === uuidForCollaboration) {
      return 
    }
    console.log("协作 2")
    let res = await store.collaborationStore.getShareReview({ reviewSessionID, getMore: 1 }).catch((error) => {
      throw error
    })
    let {ret, data} = res
    
    if (ret !== 0) {
      throw 'get ShareReview fail'
    }

    const {shareState, deadlineSeconds} = data[0]
    if(data[0].cDocID) {
      store.collaborationStore.setThisCDocId(data[0].cDocID)
    }
    // 取消分享
    if (shareState === 1) {
      store.appStore.onShowWarningMessage(() => {
        const search = window.location.search;
        if(search){
          window.history.pushState({},'','/')
        }
        store.appStore.backToHomeStart();
      }, {message:"collaboration.Dlg.stopShare", title:"PhantomPDF.Online.TitleWithOnline"}, true)
    } else if (deadlineSeconds) {
      store.collaborationStore.setDeadline(deadlineSeconds)
    }
  }
  deleteReview({ cUserID }) {
    if (store.userNewStore.userData && store.userNewStore.userData.userId && store.userNewStore.userData.userId == cUserID) {
      return;
    }

    store.appStore.onShowWarningMessage(
      () => {
        const search = window.location.search;
        if(search){
          window.history.pushState({},'','/')
        }
        store.appStore.backToHomeStart();
      },
      { message: 'CollaborationOnline.Dlg.deleteShareFile', title: 'PhantomPDF.Online.TitleWithOnline' },
      true,
    );
  }
  // newReview({ reviewType, reviewSessionID, updateTime, cUserID, email }) {}


  removeCollaboratorUser({ userId }) {
    if (store.userNewStore.userData && !store.userNewStore.userData.userId) {
      store.shareCollaborationStore.getDocCoordinationShareUserListAndSaveList()
      return;
    }
    if(userId == store.userNewStore.userData.userId) {
      store.appStore.backToHomeStart(); // 返回首页
      store.appStore.updateShowHomeStart(false) // 隐藏home窗
      store.shareCollaborationStore.setCloudShareStart(true) // 显示分享窗
      store.shareCollaborationStore.setCloudShareType("showNoAuth") // 显示无权限
      // store.appStore.onShowWarningMessage(
      //   () => {
      //     const search = window.location.search;
      //     if(search){
      //       window.history.pushState({},'','/')
      //     }
      //     store.appStore.backToHomeStart();
      //   },
      //   { message: 'CollaborationOnline.Dlg.deleteShareFile', title: 'PhantomPDF.Online.TitleWithOnline' },
      //   true,
      // );
    }
    store.shareCollaborationStore.getDocCoordinationShareUserListAndSaveList()
  }
  addCollaboratorUser() {
    // 全部成员更新用户信息列表
    store.shareCollaborationStore.getDocCoordinationShareUserListAndSaveList()
  }
  cancelShareUser() {
    // 弹窗取消分享， 返回home页
    if(this.isPublic) {
      store.appStore.viewerEventEmitter.emit('changeToolBar', 'common')
      store.appStore.setHomeHeader()
      store.shareStore.resetShare()
      store.shareCollaborationStore.resetShareCollaboration()
      return
    }
    store.appStore.backToHomeStart(); // 返回首页
    store.appStore.updateShowHomeStart(false) // 隐藏home窗
    store.shareCollaborationStore.setCloudShareStart(true) // 显示分享窗
    store.shareCollaborationStore.setCloudShareType("showNoShare") // 显示取消分享
  }
  // 不处理变更为指定人时的事件
  async changeToAppointorShare() {
    if (store.userNewStore.userData && !store.userNewStore.userData.userId) {
      return;
    }
    // 更新分享数据
    let thisHref = window.location.href
    const code = thisHref.split("code=")[1].split("&")[0]
    let openShareResult = await store.shareCollaborationStore.openShareCollaboration(code)
    if(openShareResult.code === 0) {
      // 这里，获取文档信息成功后做几层处理：
      // 0、不显示 <newHome>,替换为使用 <cloudShare>
      // store.appStore.updateShowHomeStart(false)
      // store.shareCollaborationStore.setCloudShareStart(true)
      let shareInfo = openShareResult.data
      store.shareCollaborationStore.setShareInfo(shareInfo)
    }
    // let result = await store.shareCollaborationStore.getDocCoordinationShareUserList()
    // if(result && result.code==0) {
    //   let userList = result.data
    //   store.shareCollaborationStore.setShareUserList(userList)
    //   let idList = userList.length>0 && userList.map(item => {
    //     if(item.acl == '0') { // 修改只可查看
    //       store.collaborationStore.shareCollaborationCanAnnot(false)
    //     } else if(item.acl == '1') { // 修改为可评论
    //       store.collaborationStore.shareCollaborationCanAnnot(true)
    //     }
    //     return item.userId
    //   })
    //   if(idList.includes(store.userNewStore.userData.userId.toString())) {
    //     // 当前用户在人员范围内。不退出，且将不可评论去除
    //     return
    //   }
    //   store.appStore.backToHomeStart(); // 返回首页
    //   store.appStore.updateShowHomeStart(false) // 隐藏home窗
    //   store.shareCollaborationStore.setCloudShareStart(true) // 显示分享窗
    //   store.shareCollaborationStore.setCloudShareType("showNoAuth") // 显示无权限
    // }
  }
  changeAnyShareType({acl}) {
    let secondsToGo = 9;
    if(acl == '0') { // 修改只可查看
      // 弹窗 9秒后 修改权限
      let model = info({
        icon: <ExclamationCircleOutlined style={ {color: "#f6545a"} } />,
        content: `文档所有者将权限改为【可查看】，${secondsToGo}秒后自动刷新。`,
        className: "changeAnyShareTypeDialog",
        onOk() {
          console.log("权限改为【可查看】")
          clearTimeout(news)
          store.collaborationStore.shareCollaborationCanAnnot(false)
          // 修改权限
        },
      });
      const timer = setInterval(() => {
        secondsToGo -= 1;
        model.update({
          content: `文档所有者将权限改为【可查看】，${secondsToGo}秒后自动刷新。`,
        });
      }, 1000);
      let news = setTimeout(() => {
        console.log("权限改为【可查看】")
        model.destroy()
        store.collaborationStore.shareCollaborationCanAnnot(false)
        clearInterval(timer);
      }, 9000)
    } else if(acl == '1') { // 修改为可评论
      // 弹窗 9秒后 修改权限
      let model = info({
        icon: <ExclamationCircleOutlined style={ {color: "#f6545a"} } />,
        content: `文档所有者将权限改为【可标注】，${secondsToGo}秒后自动刷新。`,
        className: "changeAnyShareTypeDialog",
        onOk() {
          console.log("权限改为【可标注】")
          clearTimeout(news)
          store.collaborationStore.shareCollaborationCanAnnot(true)
          // 修改权限
        },
      });
      const timer = setInterval(() => {
        secondsToGo -= 1;
        model.update({
          content: `文档所有者将权限改为【可标注】，${secondsToGo}秒后自动刷新。`,
        });
      }, 1000);
      let news = setTimeout(() => {
        console.log("权限改为【可标注】")
        model.destroy()
        store.collaborationStore.shareCollaborationCanAnnot(true)
        clearInterval(timer);
      }, 9000)
    }
  }
  changeShareUserAuth({acl, userId}) {
    if (store.userNewStore.userData && !store.userNewStore.userData.userId) {
      return;
    }
    if(userId == store.userNewStore.userData.userId) {
      if(acl == '0') { // 修改只可查看
        let secondsToGo = 9;
        // 弹窗 9秒后 修改权限
        let model = info({
          icon: <ExclamationCircleOutlined style={ {color: "#f6545a"} } />,
          content: `文档所有者将权限改为【可查看】，${secondsToGo}秒后自动刷新。`,
          className: "changeAnyShareTypeDialog",
          onOk() {
            console.log("权限改为【可查看】")
            clearTimeout(news)
            store.collaborationStore.shareCollaborationCanAnnot(false)
            // 修改权限
          },
        });
        const timer = setInterval(() => {
          secondsToGo -= 1;
          model.update({
            content: `文档所有者将权限改为【可查看】，${secondsToGo}秒后自动刷新。`,
          });
        }, 1000);

        let news = setTimeout(() => {
          console.log("权限改为【可查看】")
          model.destroy()
          store.collaborationStore.shareCollaborationCanAnnot(false)
          clearInterval(timer);
        }, 9000)
      } else if(acl == '1') { // 修改为可评论
        // 弹窗 9秒后 修改权限
        let secondsToGo = 9;
        let model = info({
          icon: <ExclamationCircleOutlined style={ {color: "#f6545a"} } />,
          content: `文档所有者将权限改为【可标注】，${secondsToGo}秒后自动刷新。`,
          className: "changeAnyShareTypeDialog",
          onOk() {
            console.log("权限改为【可标注】")
            clearTimeout(news)
            store.collaborationStore.shareCollaborationCanAnnot(true)
            // 修改权限
          },
        });
        const timer = setInterval(() => {
          secondsToGo -= 1;
          model.update({
            content: `文档所有者将权限改为【可标注】，${secondsToGo}秒后自动刷新。`,
          });
        }, 1000);
        let news = setTimeout(() => {
          console.log("权限改为【可标注】")
          model.destroy()
          store.collaborationStore.shareCollaborationCanAnnot(true)
          clearInterval(timer);
        }, 9000)
      }
    }
  }
}
